import React from "react";

const dateFormat = (value) => {
  if (!value) return "";
  value = new Date(value);
  return `${value.toLocaleDateString()}`;
}

const timeFormat = (value) => {
  if (!value) return "";
  value = new Date(value);
  return `${value.toLocaleTimeString()}`;
}

export default class ReservationsList extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      info: {},
      isActive: false
    };
  }

  componentDidMount() {
    window.addEventListener("keydown", this.handleKeyDown);
  }

  componentWillUnmount() {
    window.removeEventListener("keydown", this.handleKeyDown);
  }

  handleKeyDown = (e) => {
    if (e.key === "Escape") {
      this.setState({
        info: {},
        isActive: false
      })
    }
  }

  handleReservationClick = (reservation) => (e) => {
    e.preventDefault();
    this.setState({
      info: reservation,
      isActive: true
    })
  }

  handleCloseClick = (e) => {
    e.preventDefault();
    this.setState({
      info: {},
      isActive: false
    })
  }

  render() {
    const { reservations } = this.props;
    const { info, isActive } = this.state;
 
    if (reservations.length < 1) return null; 

    return (
      <div>
        <br/>
        <h4 className="title is-4">Próximas reuniões agendadas:</h4>

        <table className="table is-bordered is-hoverable is-striped is-fullwidth">
          <thead>
            <tr>
              <th className="has-text-centered" width="70%">Título</th>
              <th className="has-text-centered">Data</th>
              <th className="has-text-centered">Horário</th>
            </tr>
          </thead>
          <tbody>
            {reservations.map(reservation => (
              <tr key={reservation.series_id}>
                <td><a href="#" onClick={this.handleReservationClick(reservation)} className="is-block">{reservation.title}</a></td>
                <td className="has-text-centered">{dateFormat(reservation.start_date)}</td>
                <td className="has-text-centered">{timeFormat(reservation.start_date)}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className={`modal ${isActive ? 'is-active': null}`}>
          <div className="modal-background" onClick={this.handleCloseClick}></div>
          <div className="modal-content">
            <div className="box">
              <div className="content">
                <h4 className="title is-4">Detalhes da reserva:</h4>

                <p>
                  <strong>Início:</strong> {timeFormat(info.start_date)}
                  <br/>
                  <strong>Término:</strong> {timeFormat(info.end_date)}
                  <br/>
                </p>

                <p>
                  <strong>Descrição:</strong>
                  <br/> {info.description}
                </p>

                <strong>Locais:</strong>
                <ul>
                  {info.resources && info.resources.map(resource => (
                    <li key={resource.resource_id}>
                      {resource.name}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
          <button className="modal-close is-large" onClick={this.handleCloseClick} aria-label="close"></button>
        </div>{/* .modal */}
    
      </div>
    )
  }
}



// WEBPACK FOOTER //
// components/reservations/ReservationsList.js